import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';
import { Http } from '@angular/http';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Environment } from '../../../../environments/enviroment.model';
import { BackendService } from '../../../core/backend.service';
import { EnvironmentProvider } from '../../../core/browser-providers';
import { TranslateService } from '../../../core/translate.service';
import { SecurityService } from '../../../security/security.service';
import { DialogService } from '../../../shared-components/modals/dialog.service';
import { SearchInputComponent } from '../../../shared-components/search-input/search-input.component';
import { MediaService } from '../../../shared-services/media.service';
import { SnackService } from '../../../shared-services/snack.service';
import { UpdateEventService } from '../../../shared-services/update-event.service';
import { ActualizacionPrecio } from '../actualizacion-precio.model';
interface Filters {
  name: string;
  page: number;
  size: number;
  email?: string;
  search?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}
@Component({
  selector: 'app-precio-modificacion-list',
  templateUrl: './precio-modificacion-list.component.html',
  styleUrls: ['./precio-modificacion-list.component.scss']
})

export class PrecioModificacionListComponent implements OnInit {

  public totalItems: number;
  isLoading = false;
  private backendUrl: string;
  notificacionFiltersActive = false;

  public limiteMaxFecha = "3000-06-09T00:00:00";

  

  private filters: Filters = {
    name: undefined,
    page: 0,
    size: 10,
  };

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  actualizacionesList: ActualizacionPrecio[] = [];

  //private getNewPage = new Subject<Filters>();

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) { 
    this.backendUrl = env.endpoints.api + '/backend';
  }

  ngOnInit() {
    this.backendService.get(ActualizacionPrecio, "/productos/categorias/all-precios-actualizados", null).toPromise()
    .then((notificaciones) =>{
      this.actualizacionesList = notificaciones as ActualizacionPrecio[];
      console.log(this.actualizacionesList)
    });

   
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
  }

  addModPrecio() {
    this.router.navigate(['/modificaciones-precio/agregar']);
  }

  async deleteMod(id:number){
    
    this.snackService.spinner(true);
    try {
      await this.backendService.delete('/new-productos/delete-modificacion/'+ id);
      this.snackService.success('Modificacion Eliminada');    
   } catch (ex) {
     this.snackService.error(ex.message);
   } finally {
    
     this.snackService.spinner(false);

     this.backendService.get(ActualizacionPrecio, "/productos/categorias/all-precios-actualizados", null).toPromise()
    .then((notificaciones) =>{
      this.actualizacionesList = notificaciones as ActualizacionPrecio[];
    });
     
    
   }
    
  }

  

}



// WEBPACK FOOTER //
// ./src/app/productos/modificacion-precio/precio-modificacion-list/precio-modificacion-list.component.ts